import React, { Component, useEffect, useState } from "react";
import { Button, NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import "./css/NavMenu.css";
import { Role } from "../pages/Account";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

export let jsonHeaders = new Headers();
export let msHeaders = new Headers();
export let cmsAccount = null;

export function NavMenu() {
    const [sideBarActive, setSideBarActive] = useState(false);
    const [currentPage, setCurrentPage] = useState("");
    const [hoveringPage, setHoveringPage] = useState("");
    const [adsAdmin, setAdsAdmin] = useState(false);
    const [isLoggedin, setIsloggedin] = useState(false);

    const { instance, accounts } = useMsal();

    useEffect(() => {
        setCurrentPage(window.location.pathname);
    }, []);

    useEffect(() => {
        initMsal();
    }, [accounts]);

    async function initMsal() {
        await instance.initialize();
        const request = {
            ...loginRequest,
            account: accounts[0],
        };
        instance
            .acquireTokenSilent(request)
            .then((response) => {
                jsonHeaders.append("Authorization", `Bearer ${response.accessToken}`);
                jsonHeaders.append("Content-Type", "application/json");
                msHeaders.append("Authorization", `Bearer ${response.accessToken}`);
                fetch("https://graph.microsoft.com/v1.0/me", {
                    headers: { Authorization: `Bearer ${response.accessToken}` },
                })
                    .then((res) => res.json())
                    .then((data) => {
                        setIsloggedin(true);
                        checkAccount(data.userPrincipalName);
                    })
                    .catch((err) => console.error(err));
            })
            .catch(() => {
                handleLogin();
            });
    }

    function checkAccount(email) {
        var requestOptions = {
            method: "GET",
            headers: jsonHeaders,
            redirect: "follow",
        };

        fetch(`/api/accounts/${email}`, requestOptions)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
            })
            .then((result) => {
                if (!result) return;
                cmsAccount = result;
                if (cmsAccount.company == "ADS") setAdsAdmin(true);
            });
    }

    const handleLogin = () => {
        console.log("login");
        instance.loginRedirect(loginRequest);
    };

    const handleLogout = () => {
        instance
            .logoutPopup()
            .then(() => {
                console.log("logout");
                window.location.reload();
            })
            .catch((e) => {
                console.error(e);
            });
    };

    return (
        <div>
            <div className="side-bar-1" onMouseEnter={() => setSideBarActive(true)} onMouseLeave={() => setSideBarActive(false)}>
                <div className="tab-button-set">
                    <NavLink
                        tag={Link}
                        to="/"
                        onClick={() => {
                            setCurrentPage("/");
                        }}
                    >
                        <img src="images/ADS-CMS-new-logo.png" className="logo" />
                    </NavLink>
                    {adsAdmin ? (
                        <NavLink
                            className="tab-button"
                            tag={Link}
                            to="/manufacture"
                            style={currentPage == "/manufacture" ? { background: "#094EFF" } : {}}
                            onClick={() => {
                                setCurrentPage("/manufacture");
                            }}
                            onMouseEnter={() => {
                                setHoveringPage("/manufacture");
                            }}
                            onMouseLeave={() => {
                                setHoveringPage("");
                            }}
                        >
                            <img
                                src={
                                    currentPage == "/manufacture" || hoveringPage == "/manufacture"
                                        ? "icons/manufacture-white.svg"
                                        : "icons/manufacture.svg"
                                }
                                className="component-1"
                            />
                            <div
                                className={sideBarActive ? "tab-text tab-text-hover" : "tab-text"}
                                style={currentPage == "/manufacture" || hoveringPage == "/manufacture" ? { color: "#FFF" } : {}}
                            >
                                Manufacture
                            </div>
                        </NavLink>
                    ) : (
                        <></>
                    )}
                    <NavLink
                        className="tab-button"
                        tag={Link}
                        to="/location"
                        style={currentPage == "/location" ? { background: "#094EFF" } : {}}
                        onClick={() => {
                            setCurrentPage("/location");
                        }}
                        onMouseEnter={() => {
                            setHoveringPage("/location");
                        }}
                        onMouseLeave={() => {
                            setHoveringPage("");
                        }}
                    >
                        <img
                            src={
                                currentPage == "/location" || hoveringPage == "/location"
                                    ? "icons/location-white.svg"
                                    : "icons/location.svg"
                            }
                            className="component-1"
                        />
                        <div
                            className={sideBarActive ? "tab-text tab-text-hover" : "tab-text"}
                            style={currentPage == "/location" || hoveringPage == "/location" ? { color: "#FFF" } : {}}
                        >
                            Location
                        </div>
                    </NavLink>
                    {/* <NavLink
                            className="tab-button"
                            tag={Link} to="/setup"
                            style={currentPage == "/setup" ? { background: "#094EFF" } : {}}
                            onClick={() => { setCurrentPage("/setup") }}
                            onMouseEnter={() => { setHoveringPage("/setup") }}
                            onMouseLeave={() => { setHoveringPage("") }}>
                            <img
                                src={currentPage == "/setup" || hoveringPage == "/setup" ? "icons/device-white.svg" : "icons/device.svg"}
                                className="component-1" />
                            <div
                                className={sideBarActive ? "tab-text tab-text-hover" : "tab-text"}
                                style={currentPage == "/setup" || hoveringPage == "/setup" ? { color: "#FFF" } : {}}>
                                Device Setup
                            </div>
                        </NavLink> */}
                    <NavLink
                        className="tab-button"
                        tag={Link}
                        to="/devices"
                        style={currentPage == "/devices" ? { background: "#094EFF" } : {}}
                        onClick={() => {
                            setCurrentPage("/devices");
                        }}
                        onMouseEnter={() => {
                            setHoveringPage("/devices");
                        }}
                        onMouseLeave={() => {
                            setHoveringPage("");
                        }}
                    >
                        <img
                            src={
                                currentPage == "/devices" || hoveringPage == "/devices"
                                    ? "icons/device-hub-white.svg"
                                    : "icons/device-hub.svg"
                            }
                            className="component-1"
                        />
                        <div
                            className={sideBarActive ? "tab-text tab-text-hover" : "tab-text"}
                            style={currentPage == "/devices" || hoveringPage == "/devices" ? { color: "#FFF" } : {}}
                        >
                            Devices Manager
                        </div>
                    </NavLink>
                    <NavLink
                        className="tab-button"
                        tag={Link}
                        to="/playlists"
                        style={currentPage == "/playlists" ? { background: "#094EFF" } : {}}
                        onClick={() => {
                            setCurrentPage("/playlists");
                        }}
                        onMouseEnter={() => {
                            setHoveringPage("/playlists");
                        }}
                        onMouseLeave={() => {
                            setHoveringPage("");
                        }}
                    >
                        <img
                            src={
                                currentPage == "/playlists" || hoveringPage == "/playlists"
                                    ? "icons/list-white.svg"
                                    : "icons/list.svg"
                            }
                            className="component-1"
                        />
                        <div
                            className={sideBarActive ? "tab-text tab-text-hover" : "tab-text"}
                            style={currentPage == "/playlists" || hoveringPage == "/playlists" ? { color: "#FFF" } : {}}
                        >
                            Playlist Editor
                        </div>
                    </NavLink>
                    <NavLink
                        className="tab-button"
                        tag={Link}
                        to="/groups"
                        style={currentPage == "/groups" ? { background: "#094EFF" } : {}}
                        onClick={() => {
                            setCurrentPage("/groups");
                        }}
                        onMouseEnter={() => {
                            setHoveringPage("/groups");
                        }}
                        onMouseLeave={() => {
                            setHoveringPage("");
                        }}
                    >
                        <img
                            src={
                                currentPage == "/groups" || hoveringPage == "/groups"
                                    ? "icons/group-white.svg"
                                    : "icons/group.svg"
                            }
                            className="component-1"
                        />
                        <div
                            className={sideBarActive ? "tab-text tab-text-hover" : "tab-text"}
                            style={currentPage == "/groups" || hoveringPage == "/groups" ? { color: "#FFF" } : {}}
                        >
                            Groups
                        </div>
                    </NavLink>
                    <NavLink
                        className="tab-button"
                        tag={Link}
                        to="/schedule"
                        style={currentPage == "/schedule" ? { background: "#094EFF" } : {}}
                        onClick={() => {
                            setCurrentPage("/schedule");
                        }}
                        onMouseEnter={() => {
                            setHoveringPage("/schedule");
                        }}
                        onMouseLeave={() => {
                            setHoveringPage("");
                        }}
                    >
                        <img
                            src={
                                currentPage == "/schedule" || hoveringPage == "/schedule"
                                    ? "icons/calendar-white.svg"
                                    : "icons/calendar.svg"
                            }
                            className="component-1"
                        />
                        <div
                            className={sideBarActive ? "tab-text tab-text-hover" : "tab-text"}
                            style={currentPage == "/schedule" || hoveringPage == "/schedule" ? { color: "#FFF" } : {}}
                        >
                            Schedule
                        </div>
                    </NavLink>
                </div>

                <div className="user-button-set">
                    <NavLink
                        className="tab-button"
                        tag={Link}
                        to="/account"
                        style={currentPage == "/account" ? { background: "#094EFF" } : {}}
                        onClick={() => {
                            setCurrentPage("/account");
                        }}
                        onMouseEnter={() => {
                            setHoveringPage("/account");
                        }}
                        onMouseLeave={() => {
                            setHoveringPage("");
                        }}
                    >
                        <img
                            src={
                                currentPage == "/account" || hoveringPage == "/account"
                                    ? "icons/account-white.svg"
                                    : "icons/account.svg"
                            }
                            className="component-1"
                        />
                        <div
                            className={sideBarActive ? "tab-text tab-text-hover" : "tab-text"}
                            style={currentPage == "/account" || hoveringPage == "/account" ? { color: "#FFF" } : {}}
                        >
                            Members
                        </div>
                    </NavLink>
                    <NavLink
                        className="tab-button"
                        tag={Link}
                        to="/history"
                        style={currentPage == "/history" ? { background: "#094EFF" } : {}}
                        onClick={() => {
                            setCurrentPage("/history");
                        }}
                        onMouseEnter={() => {
                            setHoveringPage("/history");
                        }}
                        onMouseLeave={() => {
                            setHoveringPage("");
                        }}
                    >
                        <img
                            src={
                                currentPage == "/history" || hoveringPage == "/history"
                                    ? "icons/history-white.svg"
                                    : "icons/history.svg"
                            }
                            className="component-1"
                        />
                        <div
                            className={sideBarActive ? "tab-text tab-text-hover" : "tab-text"}
                            style={currentPage == "/history" || hoveringPage == "/history" ? { color: "#FFF" } : {}}
                        >
                            Update History
                        </div>
                    </NavLink>
                    {/* <NavLink
                            className="tab-button"
                            tag={Link} to="/swagger"
                            target="_blank"
                            onMouseEnter={() => { setHoveringPage("/swagger") }}
                            onMouseLeave={() => { setHoveringPage("") }}>
                            <img
                                src={currentPage == "/swagger" || hoveringPage == "/swagger" ? "icons/school-white.svg" : "icons/school.svg"}
                                className="component-1" />
                            <div
                                className={state.sideBarActive ? "tab-text tab-text-hover" : "tab-text"}
                                style={currentPage == "/swagger" || hoveringPage == "/swagger" ? { color: "#FFF" } : {}}>
                                API Docs
                            </div>
                        </NavLink> */}
                    {/* <div className="disabled-button" id="settings">
                            <img src="icons/settings.svg" className="component-1" />
                            <div className={sideBarActive ? "tab-text tab-text-hover" : "tab-text"}>
                                Settings
                            </div>
                        </div> */}
                    {!isLoggedin ? (
                        <NavLink
                            className="tab-button"
                            tag={Link}
                            onClick={() => {
                                // window.location.href = '/.auth/login/aad?post_login_redirect_uri=/'
                                handleLogin();
                            }}
                            onMouseEnter={() => {
                                setHoveringPage("/login");
                            }}
                            onMouseLeave={() => {
                                setHoveringPage("");
                            }}
                        >
                            <img
                                src={
                                    currentPage == "/login" || hoveringPage == "/login"
                                        ? "icons/login-white.svg"
                                        : "icons/login.svg"
                                }
                                className="component-1"
                            />
                            <div
                                className={sideBarActive ? "tab-text tab-text-hover" : "tab-text"}
                                style={currentPage == "/login" || hoveringPage == "/login" ? { color: "#FFF" } : {}}
                            >
                                Log In
                            </div>
                        </NavLink>
                    ) : (
                        <NavLink
                            className="tab-button"
                            tag={Link}
                            onClick={() => {
                                // window.location.href = '/.auth/logout'
                                handleLogout();
                            }}
                            onMouseEnter={() => {
                                setHoveringPage("/logout");
                            }}
                            onMouseLeave={() => {
                                setHoveringPage("");
                            }}
                        >
                            <img
                                src={
                                    currentPage == "/logout" || hoveringPage == "/logout"
                                        ? "icons/logout-white.svg"
                                        : "icons/logout.svg"
                                }
                                className="component-1"
                            />
                            <div
                                className={sideBarActive ? "tab-text tab-text-hover" : "tab-text"}
                                style={currentPage == "/logout" || hoveringPage == "/logout" ? { color: "#FFF" } : {}}
                            >
                                Log Out
                            </div>
                        </NavLink>
                    )}
                </div>
            </div>
        </div>
    );
}
